import React from "react";
import { useAppContext } from "../context/AppContext";
import ResultScreen from "../components/ResultScreen";

const ResultPage: React.FC = () => {
  const { exid, timestamp } = useAppContext();

  // Vérification que nous avons les données nécessaires
  if (!exid || !timestamp) {
    return (
      <div className="error-screen">
        <h2>Données manquantes</h2>
        <p>
          Impossible d'afficher les résultats sans les données de vérification
        </p>
      </div>
    );
  }

  return <ResultScreen exid={exid} timestamp={timestamp} />;
};

export default ResultPage;
